import { featuresProviderImpl } from "~/modules/config/FeaturesProvider/FeaturesProviderImpl/FeaturesProviderImpl";
import { FeaturesConfig } from "~/backend/generated/Features/model/featuresConfig";
import { ContextManager } from "~/modules/contextManager/ContextManager";

export const getFeaturesConfig = async (token: string, uiVersion?: string): Promise<FeaturesConfig> => {
    return featuresProviderImpl(ContextManager.newInstance())(token, uiVersion);
};
